import { createAPI } from '@common'
export default {
  // 非管理端读分类列表（按用户角色判断权限）
  getE5Cats: (config) => createAPI('customEncryptApiName-1/0nfejby.wjefp0f60dbut', 'GET', config),
  // 读分类（分组）树
  getAdminCats: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60benjo0dbut', 'GET', config),
  // 读分类回收站列表
  getAdminCatsGarbage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60benjo0dbut0hbscbhf', 'GET', config),
  // 读角色权限：分类（分组）权限
  getAdminPermissionsCats: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60benjo0qfsnjttjpot0dbut', 'GET', config),
  // 保存角色权限：分类（分组）权限
  postAdminPermissionsCats: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60benjo0qfsnjttjpot0dbut', 'POST', config),
  // 获取角色可操作界面及其权限
  getVideoActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60benjo0qfsnjttjpot0bdujpot', 'GET', config),
  // 保存角色可操作界面及其权限
  postVideoActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60benjo0qfsnjttjpot0bdujpot', 'POST', config),
    //  分类移动排序
  postAdminCatsMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60benjo0dbut0npwf', 'POST', config),
    // 获取角色分组权限
  getByCatIDPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0spmf0qfsnjttjpo0hfuCzDbuJE', 'GET', config), 
  // 修改角色分组权限
  setPermission: (config) =>
  createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0spmf0qfsnjttjpo0tfuQfsnjttjpo', 'POST', config), 
  /* 
  // 添加分类（分组）
  postAdminCats: config => createAPI('customEncryptApiName-1/0f60benjo0dbut', 'POST', config),
  // 修改分类（分组）
  putAdminCats: config => createAPI('customEncryptApiName-1/0f60benjo0dbut', 'PUT', config),
  // 删除分类（分组）
  deleteAdminCats: config => createAPI('customEncryptApiName-1/0f60benjo0dbut', 'DELETE', config),
  
  
  // 回收站列表-还原分类
  postAdminCatsRestore: (config) =>
    createAPI('customEncryptApiName-1/0f60benjo0dbut0sftupsf', 'POST', config),

  // publishcenter中使用的有权限的音视频分组接口
  getMamGroups: (config) =>
    createAPI(
      config.hubConfig ? 'CMS:/v1/mam/groups' : '/v1/mam/groups',
      'get',
      { params: config.params },
      config.hubConfig ? { hubForward: true, hub: 'e5/hub' } : null
    ),
  // publishcenter中使用的不需要权限的音视频分组接口
  getGroups: (config) => createAPI('customEncryptApiName-1/0w20hspvqt', 'GET', config) */
}
